/** Um número grande com o que ele significa embaixo. */
import { cn } from '@/lib/utils'

interface Props {
  titulo: string
  valor: string
  detalhe?: string
  className?: string
}

export function CartaoDeNumero({ titulo, valor, detalhe, className }: Props) {
  return (
    <div
      className={cn(
        'rounded-xl border border-gray-800/50 bg-[#12121a] p-4',
        className
      )}
    >
      <p className="text-xs uppercase tracking-wide text-gray-500">{titulo}</p>
      <p className="mt-1 text-2xl font-bold tabular-nums text-white">{valor}</p>
      {detalhe && <p className="mt-1 text-xs text-gray-500">{detalhe}</p>}
    </div>
  )
}
